
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/baixar",
      function () {
        return require("private-next-pages/baixar.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/baixar"])
      });
    }
  